import { initAnalytics, trackPageView } from "@/utils/analytics"
import { useRouter } from "next/router"
import { useEffect, useRef } from "react"

// Headless: loads GTM after consent and reports client-side navigations.
//
// Must stay after <SEO /> in _app — next/head commits document.title in a passive
// effect, and React runs those in tree order, so reading the title here yields the
// new page's title rather than the previous one.
const Analytics = () => {
  const router = useRouter()
  const isFirstRender = useRef(true)

  useEffect(() => initAnalytics(), [])

  useEffect(() => {
    // The initial page view is sent by the Google tag when the container loads
    if (isFirstRender.current) {
      isFirstRender.current = false

      return
    }

    trackPageView(router.asPath)
  }, [router.asPath])

  return null
}

export default Analytics
